// Pure time helpers for activity tracking (MYAC-717). No Firestore/store deps,
// so they're unit-testable in isolation.

const BUCKET_MINUTES = 30

/** Compute the local date id (YYYY-MM-DD) and 30-min slot label (HH:00|HH:30) in `tz`. */
export function localParts(d: Date, tz: string): { dayId: string; slot: string } {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
  const p = Object.fromEntries(fmt.formatToParts(d).map((x) => [x.type, x.value])) as Record<
    string,
    string
  >
  const dayId = `${p.year}-${p.month}-${p.day}`
  // Intl may emit "24" for midnight in some engines; normalize to "00".
  const hour = p.hour === '24' ? '00' : p.hour
  const minute = Number(p.minute) < BUCKET_MINUTES ? '00' : '30'
  return { dayId, slot: `${hour}:${minute}` }
}

/** Active minutes = number of true buckets × 30. */
export function activeMinutesFromBuckets(activity: Record<string, boolean> | undefined): number {
  if (!activity) return 0
  return Object.values(activity).filter(Boolean).length * BUCKET_MINUTES
}
